import {
  getApiMockParam,
  getCustomerType,
  getEventFilterIds,
  getOrganicSkus,
  getViewedSku
} from './queryParamsHelpers';
import { isValidRequest } from './helpers';

export const getQueryParams = (requestConfig) => {
  const queryParams = {};
  const isPipCarousel = requestConfig.carouselType === 'pip';

  queryParams.schema = requestConfig.schema;
  queryParams.appid = requestConfig.experienceContext.channel === 'desktop' ? 'desktop' : 'mobileweb';

  const browserid = requestConfig.experienceContext.cookie?.adobeCookie?.MCMID;
  if (browserid) {
    queryParams.browserid = browserid;
  }

  const category = requestConfig.pageContext.data?.searchModel?.metadata?.categoryID;
  if (category) {
    queryParams.category = category;
  }

  const organicskus = getOrganicSkus(requestConfig);
  if (organicskus) {
    queryParams.organicskus = organicskus;
  }

  const viewedsku = getViewedSku(requestConfig);
  if (viewedsku) {
    queryParams.viewedsku = viewedsku;
  }

  const customerType = getCustomerType(requestConfig);
  if (customerType) {
    queryParams.customerType = customerType;
  }

  const mock = getApiMockParam();
  if (mock) {
    queryParams.mock = mock;
  }

  const bannerType = requestConfig.bannerType;
  if (bannerType) {
    queryParams.bannerType = bannerType;
  }

  const carouselType = requestConfig.carouselType;
  if (carouselType && !isPipCarousel) {
    queryParams.carouselType = carouselType;
  }

  /*
   * Note: ternary operation needs to check on carouselType
   * because standard banner has no bannerType, so we need to
   * effectively use show=banner as the default.
   */
  const show = carouselType ? 'product' : 'banner';
  if (isPipCarousel) {
    queryParams.event = show;
  } else {
    queryParams.show = show;
  }

  const nValue = getEventFilterIds(requestConfig.pageContext);
  if (nValue) {
    queryParams.nValue = nValue;
  }

  const appName = window?.experienceMetadata?.name;
  if (appName) {
    queryParams.appName = appName;
  }

  const storeid = requestConfig?.experienceContext?.useStoreId;
  if (storeid) {
    queryParams.storeid = storeid;
  }

  const keyword = requestConfig.pageContext.keyword;
  if (keyword) {
    queryParams.keyword = keyword;
  }

  return queryParams;
};

export const getApiUrl = (queryParams) => {
  if (!isValidRequest(queryParams)) {
    return null;
  }
  let apiUrl = `/sponsored/v1?key=12345678912345678912345678900000&version=model2&_=${Date.now()}`;
  Object.keys(queryParams).forEach((el) => {
    apiUrl += '&' + el + '=' + queryParams[el];
  });

  return apiUrl;
};
